import {
  MouseEvent,
  FunctionComponent,
  cloneElement,
  ReactElement,
} from "react"

export type TableButtonProps = {
  action: (e: MouseEvent<HTMLButtonElement>, type?: string) => void
  label: string
  icon?: ReactElement
  disable?: boolean
  hide?: boolean
}

const ScaledSVG: FunctionComponent<{ svg: ReactElement }> = ({ svg }) => {
  const scaledSvg = cloneElement(svg, {
    width: "16",
    height: "16",
    fill: "currentColor",
  })
  return scaledSvg
}

const TableButton: FunctionComponent<TableButtonProps> = ({
  action,
  label,
  icon,
  disable = false,
  hide = false,
}) => {
  const disabledClasses =
    "bg-gray-100 text-gray-400 cursor-not-allowed border-gray-200"
  const activeClasses =
    "bg-white text-gray-700 border-gray-200 hover:bg-gray-50 hover:border-gray-300 active:bg-gray-100 cursor-pointer"
  return (
    <>
      {!hide && (
        <button
          className={`flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium rounded-lg border transition-colors ${
            disable ? disabledClasses : activeClasses
          }`}
          disabled={disable}
          onClick={action}>
          {icon && (
            <span className="flex h-4 w-4 text-gray-500">
              {ScaledSVG({ svg: icon })}
            </span>
          )}
          {label}
        </button>
      )}
    </>
  )
}

export default TableButton
